import { makeStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';

import { STATUS_PILL } from 'theme/palette';

export default makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    borderRadius: 99,
    display: 'inline-flex',
    flexGrow: 0,
    flexShrink: 0,
    fontSize: theme.typography.pxToRem(12),
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    height: 22,
    justifyContent: 'center',
    letterSpacing: 0.2,
    minWidth: 20,
    padding: theme.spacing(0.5, 1.25),
    whiteSpace: 'nowrap',
  },
  isButton: {
    cursor: 'pointer',
  },
  uppercase: {
    textTransform: 'uppercase',
  },
  primary: {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    color: theme.palette.primary.main,
  },
  secondary: {
    backgroundColor: alpha(theme.palette.secondary.main, 0.1),
    color: theme.palette.secondary.main,
  },
  error: {
    backgroundColor: STATUS_PILL.error.bg,
    color: STATUS_PILL.error.fg,
  },
  success: {
    backgroundColor: STATUS_PILL.success.bg,
    color: STATUS_PILL.success.fg,
  },
  warning: {
    backgroundColor: STATUS_PILL.warning.bg,
    color: STATUS_PILL.warning.fg,
  },
  info: {
    backgroundColor: STATUS_PILL.info.bg,
    color: STATUS_PILL.info.fg,
  },
}));
